<template>

<div class="row">
  <div class="col-md-3">
    <div class="widget">
      <div class="row vertical-align align-items-center">
        <button
          type="button"
          class="btn btn-circle btn-lg btn-primary mr-2"
        >
          <i class="fa fa-truck" />
        </button>
          <h4>{{ $t('equipments') }}</h4>
      </div>
    </div>

    <ul
      class="list-group bg-white"
      v-for="(item, index) in equipment" :key="index"
    >
      <router-link :to='`${item.path}`'>
        <li class="list-group-item text-secondary">
          <h5 class="my-1">{{ $t(item.text) }}</h5>
        </li>
      </router-link>
    </ul>
  </div>

  <div class="col-md-3">
    <div class="widget">
      <div class="row vertical-align align-items-center">
        <button
          type="button"
          class="btn btn-circle btn-lg btn-primary mr-2"
        >
          <i class="fa fa-dollar-sign" />
        </button>
          <h4>{{ $t('financial') }}</h4>
      </div>
    </div>

    <ul
      class="list-group bg-white"
      v-for="(item, index) in financial" :key="index"
    >
      <router-link :to='`${item.path}`'>
        <li class="list-group-item text-secondary" v-if="item.type === 'financial'">
          <h5 class="my-1">{{ $t(item.text) }}</h5>
        </li>
      </router-link>
    </ul>
  </div>

  <div class="col-md-3">
    <div class="widget">
      <div class="row vertical-align align-items-center">
        <button
          type="button"
          class="btn btn-circle btn-lg btn-primary mr-2"
        >
          <i class="fa fa-clipboard-list" />
        </button>
          <h4>{{ $t('services') }}</h4>
      </div>
    </div>

    <ul
      class="list-group bg-white"
      v-for="(item, index) in service" :key="index"
    >
      <router-link :to='`${item.path}`'>
        <li class="list-group-item text-secondary" v-if="item.type === 'service'">
          <h5 class="my-1">{{ $t(item.text) }}</h5>
        </li>
      </router-link>
    </ul>
  </div>

</div>
</template>

<script>
import { reports } from '@/config/settings'

export default {
  name: 'ReportsList',
  data: () => ({
    equipment: [],
    financial: [],
    service: []
  }),

  mounted () {
    const allReports = reports()

    for (const report of allReports) {
      this[report.type].push(report)
    }
  },
}
</script>
